/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import {
  CallIcon,
  FillHandIcon,
  ForwardArrowIcon,
  GalleryViewIcon,
  MuteIcon,
  RaiseHandIcon,
  RecordingIcon,
  RecordLoadingIcon,
  ScreenShareIcon,
  ShareIcon,
  SpeakerIcon,
  SpeakerSlashIcon,
  UnMuteIcon,
  VideoIcon,
  VideoSlashIcon,
} from "../../../assets/icons/svg";
import ReactTooltip from "react-tooltip";
import { globalStrings } from "../../util/translation/languages";
import { useSelector } from "react-redux";
import { _callDocUpdate, raiseHandNotification } from "../../../SocketIo";
import {
  monitorHangup,
  sendHangup,
  showRecordingButton,
  toggleAudio,
  toggleRecording,
  toggleSpeaker,
  toggleVideo,
} from "../CallCommon";
import { getAuthSession, isElectron } from "../common";
import UploadFile from "../../models/UploadFile";
import { SCREENDRAW_ENABLE } from "../../../constants";
import store from "../../../store";
import { setIsOpenWhiteBoard } from "../../redux/callSlice";

const VideoToolbar = ({
  parentProps: props,
  userHandRaise,
  raiseHand,
  toggleScreenShare,
  isLatestVersion,
  toggleSketchBoard,
  pinUserId,
  handleGalleryView,
}) => {
  const [openUploadModal, setOpenUploadModal] = React.useState(false);
  const { user_unique_key } = getAuthSession();

  const { lib, call, chat } = useSelector((state) => state);

  const { selectedLanguage } = chat || {};

  const {
    isActiveCamera,
    isActiveSpeaker,
    isActiveMic,
    isActiveScreenSharing,
    isActiveRecording,
    recordingLoader,
    isActivePenDraw,
    sharedScreenType,
    iframeLoading,
  } = lib || {};

  const { allAttendeeList, sharedFileData, hangupLoader } = call || {};

  const showShareFileIcon =
    Object.keys(sharedFileData).length > 0
      ? user_unique_key === sharedFileData?.user_id
        ? true
        : false
      : true;

  const showRecordingButtonFlag = useMemo(() => {
    return showRecordingButton(props);
  }, [props?.callDetails]);

  const toggleShareFile = (e) => {
    e.preventDefault();
    if (Object.keys(sharedFileData).length > 0) {
      const updatedCallDetail = { ...props?.callDetails };
      updatedCallDetail["sharedFile"] = {};
      _callDocUpdate(updatedCallDetail);
    } else {
      setOpenUploadModal(true);
    }
  };

  return (
    <>
      {props?.callDetails?.monitor_status === undefined ||
        (props?.callDetails?.monitor_status === false && (
          <>
            {userHandRaise ? (
              <div
                className={`toolbar__tag ${
                  hangupLoader ? "btn-disabled" : ""
                } `}
              >
                <a
                  href=""
                  className="d-flex align-items-center h-100 w-100 justify-content-center"
                  onClick={(e) =>
                    raiseHand(e, props, props.user_unique_key, false)
                  }
                >
                  <RaiseHandIcon width={25} height={25} />
                </a>
              </div>
            ) : (
              <div
                className={`tooltip position-relative toolbar__tag ${
                  hangupLoader ? "btn-disabled" : ""
                } `}
                data-tip
                data-for="handrise"
              >
                <a
                  href=""
                  className="d-flex align-items-center h-100 w-100 justify-content-center"
                  onClick={(e) => {
                    raiseHandNotification(),
                      raiseHand(e, props, props.user_unique_key, true);
                  }}
                >
                  <FillHandIcon width={25} height={25} />

                  <ReactTooltip id={"handrise"} place="top" effect="solid">
                    {globalStrings[selectedLanguage]?.$raisedHand}
                  </ReactTooltip>
                </a>
              </div>
            )}

            {isActiveMic ? (
              <div
                className={`tooltip position-relative toolbar__tag ${
                  hangupLoader ? "btn-disabled" : ""
                } `}
                data-tip
                data-for="registerTip"
              >
                <a
                  href=""
                  className="icon-audio d-flex align-items-center h-100 w-100 justify-content-center"
                  onClick={toggleAudio}
                >
                  <MuteIcon width={25} height={25} />

                  <ReactTooltip id={"registerTip"} place="top" effect="solid">
                    {globalStrings[selectedLanguage]?.$mic}
                  </ReactTooltip>
                </a>
              </div>
            ) : (
              <div
                className={`tooltip position-relative toolbar__tag ${
                  hangupLoader ? "btn-disabled" : ""
                } `}
                data-tip
                data-for="registerTipUnMute"
              >
                <a
                  href=""
                  className="icon-audio d-flex align-items-center h-100 w-100 justify-content-center"
                  onClick={toggleAudio}
                >
                  <UnMuteIcon width={25} height={25} />

                  <ReactTooltip
                    id={"registerTipUnMute"}
                    place="top"
                    effect="solid"
                  >
                    {globalStrings[selectedLanguage]?.$mic}
                  </ReactTooltip>
                </a>
              </div>
            )}

            {isActiveCamera ? (
              <div
                className={`tooltip position-relative toolbar__tag ${
                  hangupLoader ? "btn-disabled" : ""
                } `}
                data-tip
                data-for="registerTipCamra"
              >
                <a
                  href=""
                  className="icon-video d-flex align-items-center h-100 w-100 justify-content-center"
                  onClick={toggleVideo}
                >
                  <VideoIcon width={25} height={25} />
                </a>
                <ReactTooltip
                  id={"registerTipCamra"}
                  place="top"
                  effect="solid"
                >
                  {globalStrings[selectedLanguage]?.$camera}
                </ReactTooltip>
              </div>
            ) : (
              <div
                className={`tooltip position-relative toolbar__tag  ${
                  hangupLoader ? "btn-disabled" : ""
                } `}
                data-tip
                data-for="registerTipCamraOff"
              >
                <a
                  href=""
                  className="icon-video d-flex align-items-center h-100 w-100 justify-content-center"
                  onClick={toggleVideo}
                >
                  <VideoSlashIcon width={25} height={25} />
                </a>
                <ReactTooltip
                  id={"registerTipCamraOff"}
                  place="top"
                  effect="solid"
                >
                  {globalStrings[selectedLanguage]?.$camera}
                </ReactTooltip>
              </div>
            )}

            {isActiveSpeaker ? (
              <div
                className={`tooltip position-relative toolbar__tag ${
                  hangupLoader ? "btn-disabled" : ""
                } `}
                data-tip
                data-for="registerTip"
              >
                <a
                  href=""
                  className="icon-audio d-flex align-items-center h-100 w-100 justify-content-center"
                  onClick={toggleSpeaker}
                >
                  <SpeakerIcon width={25} height={25} />

                  <ReactTooltip id={"registerTip"} place="top" effect="solid">
                    {globalStrings[selectedLanguage]?.$speaker}
                  </ReactTooltip>
                </a>
              </div>
            ) : (
              <div
                className={`tooltip position-relative toolbar__tag ${
                  hangupLoader ? "btn-disabled" : ""
                } `}
                data-tip
                data-for="registerTipUnMute"
              >
                <a
                  href=""
                  className="icon-audio d-flex align-items-center h-100 w-100 justify-content-center"
                  onClick={toggleSpeaker}
                >
                  <SpeakerSlashIcon width={26} height={26} />

                  <ReactTooltip
                    id={"registerTipUnMute"}
                    place="top"
                    effect="solid"
                  >
                    {globalStrings[selectedLanguage]?.$speaker}
                  </ReactTooltip>
                </a>
              </div>
            )}

            {showShareFileIcon && (
              <div
                className={`tooltip position-relative toolbar__tag ${
                  hangupLoader ? "btn-disabled" : ""
                }  ${Object.keys(sharedFileData).length > 0 ? "selected" : ""}`}
                data-tip
                data-for="sharedFile"
              >
                <a
                  href=""
                  className="icon-video d-flex align-items-center h-100 w-100 justify-content-center"
                  onClick={toggleShareFile}
                >
                  <ShareIcon width={26} height={26} />
                </a>
                <ReactTooltip id={"sharedFile"} place="top" effect="solid">
                  {Object.keys(sharedFileData).length > 0
                    ? "Stop Sharing"
                    : "Share Audio or Video"}
                </ReactTooltip>
              </div>
            )}

            {!iframeLoading ? (
              <>
                {showRecordingButtonFlag ? (
                  recordingLoader ? (
                    <div
                      className={`toolbar__tag ${
                        hangupLoader ? "btn-disabled" : ""
                      }`}
                    >
                      <a href="#" className="d-flex align-items-center">
                        <RecordLoadingIcon width={40} height={40} />
                      </a>
                    </div>
                  ) : (
                    <div
                      data-tip
                      data-for="recording"
                      className={`tooltip position-relative toolbar__tag ${
                        hangupLoader ? "btn-disabled" : ""
                      }  ${isActiveRecording ? "selected" : ""}`}
                    >
                      <a
                        href="#"
                        className="d-flex align-items-center icon-record h-100 w-100 justify-content-center"
                        onClick={(e) => toggleRecording(e, props)}
                      >
                        <RecordingIcon width={22} height={22} />
                        <ReactTooltip
                          id={"recording"}
                          place="top"
                          effect="solid"
                        >
                          {"Recording"}
                          {/* {"Recording service is under maintenance and expect to have it resolved shortly."} */}
                        </ReactTooltip>
                      </a>
                    </div>
                  )
                ) : null}
                <div
                  data-tip
                  data-for="ScreenShere"
                  className={`tooltip position-relative toolbar__tag ${
                    hangupLoader ? "btn-disabled" : ""
                  }  ${isActiveScreenSharing ? "selected" : ""}`}
                >
                  <a
                    href=""
                    className="d-flex align-items-center icon-share h-100 w-100 justify-content-center"
                    onClick={toggleScreenShare}
                  >
                    <div className="pos-relative d-flex align-items-center justify-content-center ">
                      <ScreenShareIcon width={27} height={27} />

                      <ForwardArrowIcon
                        className="flipY-180 mt-share"
                        width="9px"
                        height="9px"
                      />

                      <ReactTooltip
                        id={"ScreenShere"}
                        place="top"
                        effect="solid"
                      >
                        {"Screen Share"}
                      </ReactTooltip>
                    </div>
                  </a>
                </div>
                <>
                  {SCREENDRAW_ENABLE &&
                    isLatestVersion &&
                    isActiveScreenSharing &&
                    isElectron &&
                    sharedScreenType === "screen" && (
                      <>
                        {isActivePenDraw ? (
                          <div
                            data-tip
                            data-for="SketchBoardOpen"
                            className={`tooltip position-relative toolbar__tag ${
                              hangupLoader ? "btn-disabled" : ""
                            } `}
                          >
                            <a
                              href=""
                              className="d-flex align-items-center icon-share h-100 w-100 justify-content-center"
                              onClick={toggleSketchBoard}
                            >
                              <div className="pos-relative d-flex align-items-center justify-content-center ">
                                <svg width="26px" viewBox="0 0 24 24">
                                  <path
                                    fill="#ffffff"
                                    d="M8.707 19.707 18 10.414 13.586 6l-9.293 9.293a1.003 1.003 0 0 0-.263.464L3 21l5.242-1.03c.176-.044.337-.135.465-.263zM21 7.414a2 2 0 0 0 0-2.828L19.414 3a2 2 0 0 0-2.828 0L15 4.586 19.414 9 21 7.414z"
                                  ></path>
                                </svg>

                                <ReactTooltip
                                  id={"SketchBoardOpen"}
                                  place="top"
                                  effect="solid"
                                >
                                  {"Pen Draw"}
                                </ReactTooltip>
                              </div>
                            </a>
                          </div>
                        ) : (
                          <div
                            data-tip
                            data-for="SketchBoardClose"
                            className={`tooltip position-relative toolbar__tag ${
                              hangupLoader ? "btn-disabled" : ""
                            } `}
                          >
                            <a
                              href=""
                              className="d-flex align-items-center icon-share h-100 w-100 justify-content-center"
                              onClick={toggleSketchBoard}
                            >
                              <div className="pos-relative d-flex align-items-center justify-content-center ">
                                <svg width="26px" viewBox="0 0 24 24">
                                  <path
                                    fill="#ffffff"
                                    d="M8.707 19.707 18 10.414 13.586 6l-9.293 9.293a1.003 1.003 0 0 0-.263.464L3 21l5.242-1.03c.176-.044.337-.135.465-.263zM21 7.414a2 2 0 0 0 0-2.828L19.414 3a2 2 0 0 0-2.828 0L15 4.586 19.414 9 21 7.414z"
                                  ></path>
                                </svg>
                                <svg
                                  className="edit-cut"
                                  stroke="currentColor"
                                  fill="currentColor"
                                  strokeWidth="0"
                                  viewBox="0 0 640 512"
                                  height="1em"
                                  width="1em"
                                >
                                  <path d="M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"></path>
                                </svg>

                                <ReactTooltip
                                  id={"SketchBoardClose"}
                                  place="top"
                                  effect="solid"
                                >
                                  {"Pen Draw"}
                                </ReactTooltip>
                              </div>
                            </a>
                          </div>
                        )}
                      </>
                    )}
                </>

                {/* <div
                      className={`tooltip position-relative toolbar__tag ${
                        isOpenWhiteBoard === true ? "bg-red" : ""
                      }`}
                      data-tip
                      data-for="registerTipwhiteBoard"
                    >
                      <a
                        href=""
                        className="icon-audio d-flex align-items-center"
                        onClick={toggleWhiteBoard}
                      >
                        <svg viewBox="2 3 20 18.6" width={25} height={25}>
                          <path
                            fill="#ffffff"
                            d="M20 3H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h4l-1.8 2.4 1.6 1.2 2.7-3.6h3l2.7 3.6 1.6-1.2L16 18h4c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 16V5h16l.001 11H4z"
                          ></path>
                          <path fill="#ffffff" d="M6 12h4v2H6z"></path>
                        </svg>

                        <ReactTooltip
                          id={"registerTipwhiteBoard"}
                          place="top"
                          effect="solid"
                        >
                          {globalStrings[selectedLanguage]?.$whiteboard}
                        </ReactTooltip>
                      </a>
                    </div> */}
              </>
            ) : null}

            {/* Back to Gallery View Start*/}
            {pinUserId !== null && (
              <div
                className={"tooltip position-relative toolbar__tag"}
                data-tip
                data-for="gellaryview"
              >
                <a
                  href=""
                  className="d-flex align-items-center h-100 w-100 justify-content-center"
                  onClick={(e) => handleGalleryView(e)}
                >
                  <GalleryViewIcon width={26} height={26} />
                  <ReactTooltip id={"gellaryview"} place="top" effect="solid">
                    {globalStrings[selectedLanguage]?.$gellaryview}
                  </ReactTooltip>
                </a>
              </div>
            )}
            {/* Back to Gallery View End*/}
          </>
        ))}
      <div data-tip data-for="EndCall">
        <a
          href=""
          className={`toolbar__tag bg-red icon-end ${
            hangupLoader ? "btn-disabled" : ""
          }`}
          onClick={(event) => {
            props?.callDetails?.monitor_status === undefined ||
            props?.callDetails?.monitor_status === false
              ? sendHangup(event, props, allAttendeeList)
              : monitorHangup(event, props, allAttendeeList);
            store.dispatch(setIsOpenWhiteBoard(false));
          }}
        >
          {hangupLoader ? (
            <div className="spin"></div>
          ) : (
            <CallIcon className="rotate-135" />
          )}

          <ReactTooltip id={"EndCall"} place="top" effect="solid">
            {"End"}
          </ReactTooltip>
        </a>
      </div>

      {openUploadModal && (
        <UploadFile
          setOpenUploadModal={setOpenUploadModal}
          openUploadModal={openUploadModal}
        />
      )}
    </>
  );
};

export default VideoToolbar;
